import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import ProjectCard from "../../common/ProjectCard";
import Service from "../../services/Service";
import BannerService from "../../services/BannerService";
import "./style.css";

const Projects = () => {
	const [data, setData] = useState([]);
	const [bg, setBg] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		new Service().getList("project").then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data?.data;
				if (!!response?.length) {
					setData(response);
				}
			}
		});
		new BannerService().getList("projects").then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data;
				if (!!response && response?.banner_images?.length) {
					setBg(response?.banner_images[0].url);
				}
			}
		});
	}, []);

	return (
		<div className="main-page">
			<Helmet>
				<title>
					{t("afkar")} | {t("Our Projects")}
				</title>
			</Helmet>
			<div className="header" style={{ backgroundImage: `url(${bg})` }}>
				<div className="shadow"></div>
				<p className="header-title">{t("Our Projects")}</p>
			</div>
			<div className="projects">
				<div className="container">
					<p className="title">{t("Our Projects")}</p>
					<div className="row">
						{data?.map((project, index) => {
							return (
								<div className="col-lg-4 col-md-6 col-12 mb-4" key={index}>
									<ProjectCard item={project} />
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};
export default Projects;
